export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              关于我们
            </h2>
          </div>

          <div className="bg-background-100 rounded-lg p-6 md:p-10">
            <div className="prose prose-sm max-w-none">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                <strong className="text-primary-600">吃瓜黑料爆料</strong>（17c吃瓜黑料爆料）成立于2024年，是国内领先的娱乐圈内幕深度追踪平台。我们专注于<strong>明星出轨内幕</strong>、<strong>娱乐圈丑闻细节</strong>的挖掘与报道，致力于为广大吃瓜群众提供最及时、最全面、最有深度的八卦事件解析。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                我们的编辑团队由资深娱乐记者、数据挖掘工程师和内容策划专家组成，采用先进的信息聚合技术结合人工审核机制，确保每一条爆料都经过多源交叉验证。从<strong>吃瓜事件时间线</strong>的精细梳理，到<strong>黑料证据整理</strong>的系统归档，我们以专业的新闻态度对待每一个八卦事件。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                平台日均更新超过50条娱乐动态，覆盖200余位活跃艺人的最新消息。我们坚持<strong>内幕爆料</strong>的独立性与客观性，不接受艺人团队的公关合作，不受资本力量的影响，只为还原最真实的娱乐圈。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                目前，吃瓜黑料爆料已累计服务超过千万用户，日均访问量突破百万。我们通过网站、APP、社交媒体等多渠道分发内容，让<strong>娱乐黑料追踪</strong>变得更加便捷高效。无论你是资深吃瓜达人还是入门新瓜友，这里都有属于你的一方天地。
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-8 border-t border-background-200/70">
              <div className="text-center">
                <p className="font-heading text-2xl font-bold text-primary-600">1000万+</p>
                <p className="text-xs text-foreground-400 mt-1">累计用户</p>
              </div>
              <div className="text-center">
                <p className="font-heading text-2xl font-bold text-primary-600">50+</p>
                <p className="text-xs text-foreground-400 mt-1">日均更新</p>
              </div>
              <div className="text-center">
                <p className="font-heading text-2xl font-bold text-primary-600">200+</p>
                <p className="text-xs text-foreground-400 mt-1">覆盖艺人</p>
              </div>
              <div className="text-center">
                <p className="font-heading text-2xl font-bold text-primary-600">3万+</p>
                <p className="text-xs text-foreground-400 mt-1">爆料存档</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}